import React from "react";
import GridContainer from "@jumbo/components/GridContainer";
import PageContainer from "@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "@jumbo/utils/IntlMessages";
import { Divider } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import HubbleDetailsContainer from "@jumbo/Dashboards/HubbleContainer/HubbleDetailsContainer";

const breadcrumbs = [
    { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
    { label: <IntlMessages id={"pages.hubble"} />, link: "/hubble" },
    {
        label: <IntlMessages id={"pages.hubbleDetails"} />,
        isActive: true,
    },
];

const HubbleDetails = () => {
    return (
        <PageContainer
            heading={<IntlMessages id="pages.hubbleDetails" />}
            breadcrumbs={breadcrumbs}
        >
            <GridContainer>
                <Grid item xs={12}>
                    <div style={{ marginBottom: "10px" }}>
                        <IntlMessages id="pages.hubbleDetails.description" />
                    </div>
                    <Divider />
                    <div style={{ marginTop: 24 }}>
                        <HubbleDetailsContainer />
                    </div>
                </Grid>
            </GridContainer>
        </PageContainer>
    );
};

export default HubbleDetails